export default "__VITE_ASSET__cfwV$RLz__"